<a-button class="sm:block sm:w-full" :href="eventViewUrl" type="primary" size="middle">Añadir evento</a-button>